export default __webpack_public_path__ + "static/media/uploadIcon.c54ecf1c.svg";